/*
 * @Author: syyoon@yongtrim.com
 * @Date: 2018-07-09 17:52:38
 * @Last Modified by: syyoon@yongtrim.com
 * @Last Modified time: 2019-01-22 00:16:54
 */

import {
  HttpInterceptor,
  HttpEvent,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
  HttpErrorResponse
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "./auth.service";
import { Observable } from "rxjs/Observable";
import { AlertService } from "./alert.service";
import { Store } from "@ngrx/store";
import { AppState } from "../app/app.reducer";
import * as AuthActions from "../store/auth/auth.action";
import { LoadingService } from "./loading.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private alertService: AlertService,
    private loadingService: LoadingService,
    private store: Store<AppState>
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return Observable.fromPromise(this.handleAccess(req, next));
  }

  private async handleAccess(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Promise<HttpEvent<any>> {
    const token = this.authService.token;

    // HttpHeader object immutable - copy values
    const headerSettings = {};
    for (const key of request.headers.keys()) {
      headerSettings[key] = request.headers.getAll(key);
    }

    if (!headerSettings["Authorization"]) {
      if (token) {
        headerSettings["Authorization"] = "Bearer " + token;
      }
      if (!headerSettings["my-content-type"])
        headerSettings["Content-Type"] = "application/json";
    }

    return next
      .handle(
        request.clone({
          headers: new HttpHeaders(headerSettings)
        })
      )
      .do(
        (event: HttpEvent<any>) => {},
        (err: any) => {
          this.loadingService.showLoading(false);
          if (err && err instanceof HttpErrorResponse) {
            if (err.status === 403) {
              this.alertService.showConfirmMessage(
                "비회원 사용 불가",
                "회원만 사용하실 수 있는 기능입니다. 가입하시겠습니까?",
                () => {
                  this.store.dispatch(new AuthActions.Logout());
                }
              );
            } else if (err.error) {
              this.alertService.showToastErrorMessage(err.error);
            }
          }
        }
      )
      .toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/services/auth.interceptor.ts